import { render } from "./PrescriberProxyUserDetails.vue?vue&type=template&id=2b16cc18&scoped=true"
import script from "./PrescriberProxyUserDetails.vue?vue&type=script&lang=js"
export * from "./PrescriberProxyUserDetails.vue?vue&type=script&lang=js"

import "./PrescriberProxyUserDetails.vue?vue&type=style&index=0&id=2b16cc18&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b16cc18"]])

export default __exports__